import { observer } from 'mobx-react'
import { FC } from 'react'
import GoodsDetailModal from '@/components/GoodsDetailModal/GoodsDetailModal'
import OpenVipModal from '@/components/OpenVipModal/OpenVipModal'
import PayModal from '@/components/PayModal/PayModal'
import CustomerServiceModal from '@/components/CustomerServiceModal/CustomerServiceModal'
import ExchangeCodeModal from '@/components/ExchangeCodeModal/ExchangeCodeModal'
import { ExchangeSuccessModal } from '@/components/ExchangeCodeModal/ExchangeCodeModal'
import LoginModal from '@/components/LoginModal/LoginModal'
import PaySuccessModal from '@/components/PaySuccessModal/PaySuccessModal'
import CustomMadeModal from '@/components/CustomMadeModal/CustomMadeModal'
import NewUserActivityModal from '@/components/NewUserActivityModal/NewUserActivityModal'
import { uiController } from '@/controllers/uiController'
import { userService } from '@/services/userService'
import { dayjsHelper } from '@/helpers/dayjsHelper'
import NewUserActivity from '@/components/NewUserActivityModal/NewUserActivity'

interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer(
  (props: CommonDialogLayoutProps) => {
    return (
      <div>
        {uiController.goodsDetailModalProps.visible && (
          <GoodsDetailModal {...uiController.goodsDetailModalProps} />
        )}
        {uiController.openVipModalProps.visible && (
          <OpenVipModal {...uiController.openVipModalProps} />
        )}
        {uiController.payModalProps.visible && <PayModal {...uiController.payModalProps} />}
        {uiController.customerServiceModalProps.visible && (
          <CustomerServiceModal {...uiController.customerServiceModalProps} />
        )}
        {uiController.exchangeCodeModalProps.visible && (
          <ExchangeCodeModal {...uiController.exchangeCodeModalProps} />
        )}
        {uiController.exchangeSuccessModalProps.visible && (
          <ExchangeSuccessModal {...uiController.exchangeSuccessModalProps} />
        )}
        {uiController.loginModalProps.visible && <LoginModal {...uiController.loginModalProps} />}
        {uiController.paySuccessModalProps.visible && (
          <PaySuccessModal {...uiController.paySuccessModalProps} />
        )}
        {uiController.customMadeModalProps.visible && (
          <CustomMadeModal {...uiController.customMadeModalProps} />
        )}
        {/* {uiController.newUserActivityModalProps.visible && (
          <NewUserActivityModal {...uiController.newUserActivityModalProps} />
        )}
        {userService.newUserActivity?.activityFlag &&
          !uiController.newUserActivityModalProps.visible &&
          !dayjsHelper.countdown(userService.newUserActivity?.activityEnd * 1000).isExpired && (
            <NewUserActivity />
          )} */}
      </div>
    )
  }
)

export default CommonDialogLayout
